<script>
import SiteHeader from './components/SiteHeader';
import IntroSection from './components/IntroSection';
import PortraitSection from './components/PortraitSection';
import ContactSection from './components/ContactSection';
import SiteFooter from './components/SiteFooter';

export default {
    name: 'app',
    components: {
        SiteHeader,
        IntroSection,
        PortraitSection,
        ContactSection,
        SiteFooter
    },
};
</script>

<template>
    <div id="app">
        <main class="app-content">
            
            <site-header />
            <div class="app-content__intro">
                <img src="./assets/images/background-intro-lg.svg" alt="" class="app-content__background">
                <intro-section />
            </div>
            <div class="app-content__sections">
                <img src="./assets/images/background-lg.svg" alt="" class="app-content__background">
                <portrait-section />
                <contact-section />
                <site-footer />
            </div>
        </main>
    </div>
</template>

<style lang="scss">
@import './styles/common';
@import './styles/variables';
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $color-primary;
}
.app-content {
    position: relative;
    width: 100%;
    // height: 300vh;
    overflow: hidden;

    @media (max-width: 960px) {
        height: auto;
        background-image: url('./assets/images/background-md.svg');
        background-repeat: no-repeat;
        background-position: center top;
        background-size: cover;
    }

    @media (max-width: 760px) {
        background-image: url('./assets/images/background-sm.svg');
    }
}
.app-content__intro {
    position: relative;
    width: 100%;
    height: 100vh;

    @media (max-width: 960px) {
        height: auto;
    }
}
.app-content__sections {
    position: relative;
    width: 100%;
    height: 96rem;

    @media (max-width: 960px) {
        height: auto;
    }
}
.app-content__background {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;

    @media (max-width: 960px) {
        display: none;
    }
}
</style>
